var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-lg-9 d-flex pr-md-0" }, [
      _c(
        "div",
        {
          staticClass: "row total-stats-block",
          attrs: { "data-keyload": "middle_row_now_count" },
        },
        [
          _c(
            "div",
            { staticClass: "pearls row col-lg-12 pt-20 panel pb-20" },
            _vm._l(_vm.stats, function (stat, type) {
              return _c(
                "div",
                { staticClass: "pearl col-lg-3", class: stat.class },
                [
                  stat.error
                    ? _c("div", { staticClass: "pearl-icon" }, [
                        _c("i", {
                          staticClass: "fa fa-exclamation-triangle pearl-blue",
                          attrs: { "aria-hidden": "true" },
                        }),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !stat.error && stat.loading
                    ? _c("div", { staticClass: "pearl-icon" }, [
                        _c("i", {
                          staticClass: "fa fa-spinner fa-pulse pearl-blue",
                          attrs: { "aria-hidden": "true" },
                        }),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !stat.error && !stat.loading
                    ? _c(
                        "div",
                        { staticClass: "pearl-icon", style: stat.font_style },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(stat.count) +
                              "\n          "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("span", { staticClass: "pearl-title" }, [
                    _c("span", { domProps: { innerHTML: _vm._s(stat.title) } }),
                  ]),
                ]
              )
            }),
            0
          ),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-lg-3" }, [
      _c("div", { staticClass: "row", staticStyle: { height: "100%" } }, [
        _c("div", { staticClass: "pearls row col-lg-12 pt-20 panel pb-20" }, [
          _c(
            "div",
            {
              staticClass: "pearl col-lg-12 red active",
              attrs: {
                "aria-expanded": "true",
                "data-keyload":
                  "color_status_count_not_completed_exam_user4group",
              },
            },
            [
              _c(
                "a",
                {
                  attrs: {
                    href: "/q/learncontrol/all_stat_persons4groups?externvar[student_control_type]=4&externvar[def_is_active_group]=50",
                    target: "_self",
                  },
                },
                [
                  _vm.not_finished_learning.error
                    ? _c("span", { staticClass: "pearl-icon cursor-pointer" }, [
                        _c("i", {
                          staticClass: "fa fa-exclamation-triangle pearl-red",
                          attrs: { "aria-hidden": "true" },
                        }),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.not_finished_learning.error &&
                  _vm.not_finished_learning.loading
                    ? _c("span", { staticClass: "pearl-icon cursor-pointer" }, [
                        _c("i", {
                          staticClass: "fa fa-spinner fa-pulse pearl-red",
                          attrs: { "aria-hidden": "true" },
                        }),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.not_finished_learning.error &&
                  !_vm.not_finished_learning.loading
                    ? _c(
                        "span",
                        {
                          staticClass: "pearl-icon cursor-pointer",
                          style: _vm.not_finished_learning.font_style,
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.not_finished_learning.count) +
                              "\n            "
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _c("span", { staticClass: "pearl-title" }, [
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(_vm.not_finished_learning.title),
                  },
                }),
                _vm._v(" "),
                _c("i", {
                  staticClass: "icon md-help-outline cursor-pointer",
                  attrs: {
                    "aria-hidden": "true",
                    "data-toggle": "popover",
                    "data-html": "true",
                    "data-trigger": "click | hover",
                    "data-content":
                      "Рассчитывается на основании человек-группа",
                  },
                }),
              ]),
            ]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }